// Default form data for new projects
export const defaultFormData = {
  projectName: "",
  societyName: "",
  location: "",
  plotAreaPerCard: "0",
  plotAreaUnit: "sqmtr",
  roadWidth: "0",
  projectClassification: "non-tod",
  projectMode: "redevelopment",
  jvType: "area_sharing",
  jvRatioPercent: "30",
  jvRatioFlats: "",
  jvRatioOffices: "",
  jvRatioShops: "",
  jvRatioResidential: "",
  jvRatioCommercial: "",
  jvSecurityDepositRefundable: "",
  jvSecurityDepositNonRefundable: "",
  jvSecurityDeposit: "",
  jvSecurityDepositType: "refundable",
  jvRatioCustom: "0",
  numMembers: "0",
  hasFlats: true,
  hasOffices: false,
  hasShops: false,
  areaFlats: "0",
  areaOffices: "0",
  areaShops: "0",
  areaTerrace: "0",
  areaOverheadTerrace: "0",
  areaGarden: "0",
  hasTerraceGarden: "",
  terraceConversionRatio: "0",
  overheadTerraceConversionRatio: "0",
  gardenConversionRatio: "0",
  applyIncrementOnTerraceGarden: "no",
  additionalFreeAreaPercent: "0",
  areaOfferMode: "percentage",
  directAreaOfferedSqft: "0",
  allottedParkings: "0",
  existingParkings: "0",
  hasExistingParking: "",
  parkingCompensationType: "none",
  compensationParkingCount: "0",
  compensationCarpetArea: "0",
  compensationPayout: "0",
  fourWheelerPerMember: "0",
  twoWheelerPerMember: "0",
  completionYear: "",
  existingBuiltupArea: "0",
  existingRoadWidening: "0",
  hasExistingTDR: "no",
  existingTDRArea: "0",
  ulcSection20: "no",
  ulcArea: "0",
  buildingHeight: "24",
  constructionCostPerSqft: "2800",
  // Recreational Floor
  hasRecreationalFloor: "no",
  recreationalFloorAreaSqft: "0",
  // Basements
  hasBasements: "no",
  numBasements: "0",
  basementAreaPerFloorSqft: "0",
  basementCostPerSqft: "0",
  // Additional Parking Floors
  hasAdditionalParkingFloors: "no",
  numAdditionalParkingFloors: "0",
  additionalParkingFloorAreaSqft: "0",
  additionalParkingCostPerSqft: "0",
  useLowerFSI: "no",
  customLowerFSI: "0",
  mhadaNumBuildings: "1",
  mhadaSanctionRate: "300",
  rrZone: "",
  villageName: "",
  rrRatePlot: "0",
  rrRateFlat: "0",
  rrRateOffice: "0",
  rrRateShop: "0",
  hasOldRoadWidening: "no",
  oldRoadWideningArea: "0",
  hasNewRoadWidening: "no",
  newRoadWideningArea: "0",
  bankGuaranteeRequired: "no",
  bankGuaranteeAmount: "0",
  areaUnit: "sqft",
  roadWidthUnit: "meters",
  greenRatingRequired: "true",
  greenFSICategory: "silver",
  projectType: "residential",
  slumTDRPercentage: "30",
  residentialPercentage: "100",
  commercialPercentage: "0",
  shiftingCharges: "0",
  corpusCharges: "0",
  bettermentChargesType: "per_member",
  bettermentCharges: "0",
  bettermentChargesOffices: "",
  bettermentChargesShops: "",
  // Include-flags for society expense sections (toggle to skip a charge entirely)
  includeRent: true,
  includeCorpusCharges: true,
  includeBettermentCharges: true,
  includeShiftingCharges: true,
  // Commercial GST offset (%). Commercial GST rate = 12 − offset; default offset 5 → net 7%
  commercialGSTOffset: "5",
  config1BHK: "0",
  config2BHK: "0",
  config3BHK: "0",
  configShops: "0",
  configOthers: "0",
  rentType: "per_sft",
  rentPerSqftFlat: "0",
  rentPerSqftOffice: "0",
  rentPerSqftShop: "0",
  rentLumpsum1BHK: "0",
  rentLumpsum2BHK: "0",
  rentLumpsum3BHK: "0",
  rentLumpsumShops: "0",
  rentLumpsumOthers: "0",
  rentIncrementPA: "5",
  shopRentDuration: "0",
  shopRentIncrement: "0",
  projectDuration: "0",
  additionalArea: "0",
  refundableDeposit: "no",
  depositMonths: "1",
  brokeragePayable: "no",
  brokerageMonths: "1",
  societyPMCPayable: "no",
  pmcAmount: "0",
  bgRatePA: "8",
  bgStagedRelease: "no",
  buildingAge: "0",
  rrRateConstruction: "27951",
  amenityTDRPercent: "0",
  slumTDRMethod: "zone_drc",
  slumTDRZoneDRC: "0",
  slumTDRRRPercent: "0",
  fireFightingRate: "0",
  carpetAreaFactor: "0",
  additionalFreeCarpetArea: "0",
  loadingPercentage: "40",
  loadingPercentageFlats: "40",
  loadingPercentageOffices: "35",
  loadingPercentageShops: "35",
  isProjectAwarded: "no",
  awardedTo: "",
  awardedToCompetitorIndex: 0,
  competitors: [],
  // Legacy single competitor fields (for backward compatibility)
  competitorName: "",
  competitorAdditionalAreaPercent: "",
  competitorRentPerSqftFlat: "",
  competitorRentPerSqftShop: "",
  competitorBettermentCharges: "",
  competitorCorpusCharges: "",
  competitorShiftingCharges: "",
  competitorAreaSharingPercent: "",
  competitorProjectDuration: "",
  saleRatePerSqft: "",
  // Separate sale rates for different property types
  saleRateFlats: "",
  saleRateOffices: "",
  saleRateShops: "",
  saleableAreaSplitOffices: "",
  saleableAreaSplitShops: "",
  // Marketing expense as percentage or per sft
  marketingExpenseMode: "percent",
  marketingExpenseType: "percent",
  marketingExpensePercent: "3",
  marketingCostPerSqft: "",
  // Corpus and betterment charge types
  corpusChargesType: "per_member",
  // Betterment payment timing
  bettermentPaymentTiming: "at_possession",
  // Separate free area percentages for each property type
  freeAreaPercentFlats: "0",
  freeAreaPercentOffices: "0",
  freeAreaPercentShops: "0",
  projectInterestRate: "12",
  rrMultiplier: "5",
  proposedBuiltUpArea: "",
  fsi: "",
  numUnits: "",
  numFloors: "",
  proposedFlatsArea: "",
  proposedOfficesArea: "",
  proposedShopsArea: "",
  constructionCost: "",
  // Other Costs
  miscExpPerSqft: "",
  brokerageCommissionType: "fixed",
  brokerageCommissionFixed: "",
  brokerageCommissionPerSqft: "",
  legalCosts: "",
  marketingCosts: "",
  otherCosts: "",
  contingency: "10",
  // DA Charges fields
  stampDutyRate: "5",
  registrationChargesRate: "1",
  scrutinyChargesRate: "",
  lbtChargesRate: "",
  // Cash Flow Analysis config
  cashflowConfig: null,
  // Additional fields
  hasTitbitArea: "no",
  titbitArea: "0",
  applyRRMarkup: "no",
  rrAdditionalMarkupPercent: "",
  tdrSplitRatio: "70:30",
  tdrSplitAmenity: 70,
  tdrSplitSlum: 30,
  count1BHK: "",
  count2BHK: "",
  count3BHK: "",
  count4BHK: "",
  rent1BHK: "",
  rent2BHK: "",
  rent3BHK: "",
  rent4BHK: ""
};

// Empty competitor template
export const emptyCompetitor = {
  id: "", // Will be generated on creation
  name: "",
  additionalAreaPercent: "",
  areaSharePercent: "",
  freeAreaPercent: "",
  rentPerSqftFlat: "",
  rentPerSqftShop: "",
  bettermentCharges: "",
  bettermentChargesType: "per_member",
  corpusCharges: "",
  corpusChargesType: "per_member",
  shiftingCharges: "",
  projectDuration: "",
  saleRate: "",
  notes: ""
};

// Generate unique competitor ID
export const createCompetitor = () => ({
  ...emptyCompetitor,
  id: `comp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
});

// Construction costs by building height
export const defaultConstructionCosts = {
  "24": 2800,
  "36": 3000,
  "45": 3200,
  "70": 3600,
  "100": 4200
};

// Carpet area factor by building height
export const carpetFactorByHeight = {
  "24": "87",
  "36": "85",
  "45": "82",
  "70": "82",
  "100": "80"
};
